import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./contexts/authContext";

export const AuthenticatedRoute = ({ children }) => {
    const { isAuthenticated } = useAuth();
    const location = useLocation();

    return isAuthenticated()
        ? children
        : <Navigate to={{ pathname: `/auth/login` }} state={{ from: location }} />;
};